import clsx from 'clsx';
import type React from 'react';
import { Icon } from '#common/components/Icon';

interface Props {
    isChecked: boolean;
    uncheckedOnlyBorder?: boolean;
    name?: string;
    onChange: (isChecked: boolean) => void;
    label: string | React.ReactNode;
    className?: string;
    labelPosition?: 'left' | 'right';
    disabled?: boolean;
}

export function Checkbox(
    { isChecked, onChange, uncheckedOnlyBorder, label, name, className, labelPosition = 'right', disabled }: Props,
) {
    return (
        <label
            className={clsx(
                'select-none flex flex-row items-center gap-x-2',
                className,
                disabled && 'opacity-50 cursor-not-allowed'
            )}
        >
            {labelPosition === 'left' && label}
            <Icon
                icon={isChecked ? 'fa--check-square' : (uncheckedOnlyBorder ? 'fa--square-o' : 'fa--square')}
                className='shrink-0'
            />
            {labelPosition === 'right' && label}
            <input
                className='hidden'
                type='checkbox'
                name={name}
                checked={isChecked}
                onChange={e => onChange(e.target.checked)}
            />
        </label>
    );
}
